<div class="summary" >
    <div class="subject-wrapper float-left">
        <em class="c-icon c-icon--{{this.wybierzIkoneDlaPrzedmiotu()}} u-icon--big"></em>
        <div class="subject">
            <span class="label">Przedmiot zgłoszenia:</span>
            <span class="name">{{ opisLokalizacji }}</span>
        </div>
    </div>
    <div class="d-flex float-right">
        <em class="icon" (click)="usunZbiorUszkodzen({zbiorUszkodzenPrzedmiotowId: zbiorUszkodzenPrzedmiotuId, zbiorUszkodzenId: zbiorUszkodzenId})" title="Usuń">
            <img src="assets/images/trash_bin.png" alt="Usuń">
        </em>
    </div>
</div>
